export enum DocTypes  {
  AUX= 'AUX',
  REQ= 'REQ',
  INT= 'INT',
  MED= 'MED',
  QA= 'QA',
  COVER= 'COVER',
  NOTE= 'NOTE',
  RECEIPT= 'RECEIPT',
  RELEASE= 'RELEASE'
} 
